<template>
  <div class="service-code">
    <div class="card services">
      <div class="title">
        <div class="cloumn">
          <span v-if="use != -1">{{total - use}}</span>
          <span v-if="use != -1" class="sub">可使用(次)</span>
          <span class="sub" v-else>已失效</span>
          <div class="bd-lt-bg">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="label ">
          <span>屏幕贴膜</span>
          <span class="sub">
            {{`已使用${use || "0"}张 共${total || "0"}张`}}
          </span>
        </div>
      </div>
      <div class="des">
        <div class="servie-process">
          <h3>简单<span>3</span>步，尊享VIP服务</h3>
          <div class="step">
            <i><img src="../../assets/call_order.png"/></i
            ><span>联系客服预约</span>
          </div>
          <div class="line"></div>
          <div class="step">
            <i><img src="../../assets/service_code.png"/></i
            ><span>短信收取服务码</span>
          </div>
          <div class="line"></div>
          <div class="step">
            <i><img src="../../assets/show_sn.png"/></i
            ><span>门店出示享受服务</span>
          </div>
        </div>
        <div class="fill"></div>
      </div>
      <div class="bottom">
        <div class="agreement" @click="gotoAgreement">查看详细服务条款</div>
        <div class="btn">
          <y-button @click="call">联系客服预约</y-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpOpen } from "../../scripts/network";
import { login } from "../../scripts/auth";
// import { getAgreementUrl } from "../../scripts/care_agreement";
export default {
  name: "ServiceCode",
  data() {
    return {
      type: -1,
      use: 0,
      total: 0,
      services: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.loadData();
  },
  methods: {
    showCode(index) {
      this.$set(this.services[index], `show`, true);
    },
    async loadData() {
      try {
        this.$loading.show("加载中...");
        const ret = await httpOpen("/WuYouCard/FilmServiceApply", {
          type: "post",
          body: {
            CardSysNo: this.id
          }
        });
        this.$loading.hide();
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast("加载失败");
          return;
        }
        this.use = ret.Data.UseMoTotalNum;
        this.total = ret.Data.EquityTotalCount;
      } catch (e) {
        this.$loading.hide();
        console.error(e);
      }
    },
    async getCareType(id) {
      this.$loading.show("请稍后");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardInfo", {
          type: "post",
          body: { CardSysNo: id }
        });
        this.$loading.hide();
        if (!ret.Status) {
          return -1;
        }
        return ret.Data.ServiceType;
      } catch (e) {
        console.error(e);
        this.$loading.hide();
      }
    },
    call() {
      window.location.href = "tel:400-088-9898";
    },
    async gotoAgreement() {
      // this.$loading.show("请稍等");
      // const url = await getAgreementUrl(this.id, null, this.type);
      // this.$loading.hide();
      // this.goto(url);
      this.goto(`/agreement?id=${this.id}`);
    }
  }
};
</script>

<style lang="less">
.service-code {
  min-height: 100vh;
  background: #efefef;
  font-size: 14px;
  color: black;
  font-weight: 500;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .card {
    display: block;
    box-sizing: border-box;
    &.services {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      .fill {
        flex: 1 1;
      }
      .title {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        font-weight: bold;
        background: linear-gradient(360deg,#161616, #000000);
        border-radius: 0px 11px 11px 0px;
        position: relative;
        overflow: hidden;
        .cloumn {
          display: flex;
          padding: 5% 16px;
          flex-direction: column;
          background: linear-gradient(180deg,#f8ead9, #d0bb9e);
          border-radius: 8px 0px 0px 8px;
          margin:6px 0px 6px 16px;
          text-align: center;
          font-size: 35px;
          width: 30%;
          .sub {
            font-size: 12px;
            margin-top: 4px;
          }
          .left{
            font-size:16px;
            font-weight: 500;
          }
          .bd-lt-bg{
            width: 20px;
            position: absolute;
            top:0;
            left: -12px;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            span{
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 100%;
              background-color: #efefef;
            }
          }
        }
        .label{
          width: 70%;
          display: flex;
          flex-direction: column;
          color: #fff;
          font-size: 17px;
          background: linear-gradient(270deg,#202020, #424242);
          align-items: center;
          justify-content: center;
          line-height: 2;
          .sub{
            font-size: 12px;
            color: #999;
          }
        }
      }
      .des{
        background-color: #fff;
        border-radius: 6px;
        margin-top: 14px;
        padding: 20px 26px;
        .servie-process {
          h3 {
            font-size: 16px;
            font-weight: 600;
            background: linear-gradient(90deg,#f2ddc6, #d0ad8d);
            border-radius: 2px;
            padding: 4px 9px;
            margin-bottom: 40px;
            span{
              color: #DA2B2B;
            }
          }
          .step {
            height: 28px;
            display: flex;
            flex-direction: row;
            align-items: center;
            counter-increment: step;
            i,
            img {
              max-width: 46px;
            }
            i {
              margin-right: 16px;
            }
            span {
              font-size: 14px;
              color: black;
              font-weight: 600;
            }
          }
          .line {
            height: 18px;
            width: 7px;
            background: rgba(241,220,197,0.33);
            margin: 10px 0 10px 10px;
          }
          .step::before {
            content: counter(step);
            display: block;
            text-align: center;
            color: #000;
            font-size: 18px;
            margin-right: 26px;
            font-weight: bold;
            background: linear-gradient(180deg,#f4e0c9, #ceab8b);
            width: 24px;
            height: 24px;
            border-radius: 100%;
          }
        }
      }
      .bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        .agreement {
          font-size: 14px;
          color: #000;
          text-align: center;
          padding: 8px;
        }
        .btn{
          background-color: #fff;
          padding: 10px 20px;
        }
      }
    }
  }
}
</style>